module.exports = __webpack_public_path__ + "img/seaLogo.236dd864.png";